module.exports = __webpack_public_path__ + "static/media/AnxietyActive.4a1d9513.svg";